var _rect, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconLayersThree02(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 4,
    fill: "#00A198"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.816 4.722a1 1 0 01.368 0c.145.027.274.093.336.125l.017.008 6.428 3.214a.667.667 0 010 1.193l-6.428 3.214-.017.009c-.063.032-.191.097-.335.124a.998.998 0 01-.37 0 1.263 1.263 0 01-.335-.124l-.017-.009-6.428-3.214a.667.667 0 010-1.193l6.428-3.214.018-.008c.062-.032.19-.098.335-.125z",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.685 11.078l-.65.325a.667.667 0 000 1.192l6.428 3.214.018.009c.062.032.19.097.335.125a.998.998 0 00.368 0c.145-.028.274-.093.336-.125l.017-.009 6.428-3.214a.667.667 0 000-1.192l-.65-.325-5.182 2.59-.008.005c-.032.016-.113.056-.193.091a2.324 2.324 0 01-1.864 0c-.08-.035-.16-.075-.193-.091l-.008-.004-5.182-2.591z",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.685 14.411l-.65.325a.667.667 0 000 1.193l6.428 3.214.018.008c.062.032.19.098.335.125a.998.998 0 00.368 0c.145-.027.274-.093.336-.125l.017-.008 6.428-3.214a.667.667 0 000-1.193l-.65-.325-5.182 2.59-.008.005c-.032.016-.113.056-.193.091a2.33 2.33 0 01-1.362.156 2.33 2.33 0 01-.502-.156c-.08-.035-.16-.075-.193-.091l-.008-.004-5.182-2.591z",
    fill: "#fff"
  })));
}
export default SvgIconLayersThree02;